import React from 'react';
import styles from '../style.module.scss';
import { Col, Radio, Row, Space, Typography } from 'antd';
import { Link } from 'react-router-dom';
import Button from 'components/button';
import { useTranslation } from 'react-i18next';
import useECommerce from '../useECommerce';

const FirstStep = () => {
  const {
    eCommercesTypes,
    handleSetDefaultState,
    eCommerceData,
    handleSetCurrentECommerceType,
    handleSaveFistStep,
    loading,
  } = useECommerce();
  const { t } = useTranslation();
  return (
    <Row className={styles.row} justify={'space-between'}>
      <Col span={24}>
        <Row>
          <Col span={24}>
            <Typography.Text strong>
              {t('Seleziona e-commerce')}
            </Typography.Text>
          </Col>
          <Col span={10}>

          </Col>
          <Col span={24}>
            <br />
            <Radio.Group
              onChange={handleSetCurrentECommerceType}
              value={eCommerceData.currentECommerceType}
            >
              <Space direction='vertical'>
                <Radio value={eCommercesTypes.prestashop}>Prestashop</Radio>
                <Radio value={eCommercesTypes.woocommerce}>Woocommerce</Radio>
                <Radio value={eCommercesTypes.wix}>Wix Commerce</Radio>
                <Radio value={eCommercesTypes.shopify}>Shopify</Radio>
              </Space>
            </Radio.Group>
          </Col>
        </Row>
      </Col>
      <Col flex={1}>
        <Row
          className={styles.btnsRow}
          align={'bottom'}
          justify={'end'}
          gutter={8}
        >
          <Col>
            <Link to={'/products'}>
              <Button onClick={handleSetDefaultState}>{t('Annulla')}</Button>
            </Link>
          </Col>
          <Col>
            <Button
              onClick={handleSaveFistStep}
              loading={loading}
              disabled={!eCommerceData.currentECommerceType}
            >
              {t('Salva e continua')}
            </Button>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default FirstStep;
